import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';
import { addEntryPointClickedAnalytics } from '../ui/utils/analytics';

import type { StartThinkingAction } from './types';

export const startThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => StartThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(options): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				if (options?.entryPoint) {
					addEntryPointClickedAnalytics(api?.analytics?.actions)(tr, options.entryPoint);
				}
				tr.setMeta(thinkingPluginKey, {
					status: 'thinking',
				});
				return tr;
			}) || false
		);
	};
